export const PAYMENT_LINK_HEADERS = [
	'No.',
	'Created At',
	'Status',
	'Canceled At',
	'Paid At',
];
